export default { sha: 'ea2e33bd716ee6cb2d7347703f564b504e4edf60', buildNumber: 'undefined' }
